import './LeadText.scss';
import clsx from 'clsx';
import React from 'react';

type Props = {
  className?: string;
  as?: React.ElementType;
  children: React.ReactNode;
};

export const LeadText = (props: Props): React.ReactElement => {
  const { className, as: Cmp = 'h6', children } = props;

  return (
    <Cmp className={clsx('bp-lead-text', className)}>
      {children}
    </Cmp>
  );
};
